
import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from '../../utils/axios';
// utils

import mockData from '../../utils/mock-data';
import { sample } from 'lodash';
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  mails: { byId: {}, allIds: [] },
  labels: []
};

const slice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LABELS
    getLabelsSuccess(state, action) {
      state.isLoading = false;
      state.labels = action.payload;
    },

    // GET MAILS
    getMailsSuccess(state, action) {
      const mails = action.payload;

      state.isLoading = false;
      state.mails.byId = objFromArray(mails);
      state.mails.allIds = Object.keys(state.mails.byId);
    },

    // GET MAIL
    getMailSuccess(state, action) {
      const mail = action.payload;

      state.mails.byId[mail.id] = mail;
      if (!state.mails.allIds.includes(mail.id)) {
        state.mails.allIds.push(mail.id);
      }
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getLabels() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // const response = await axios.get('/api/mail/labels');
      // dispatch(slice.actions.getLabelsSuccess(response.data.labels));
      const labels = [
        { id: 'all', type: 'system', name: 'Danh bạ', countContact: 3 },
        { id: 'upload', type: 'system', name: 'Tải lên danh bạ', countContact: 1 },
        { id: 'getlink', type: 'system', name: 'Lấy link phonebook', countContact: 0 },
        // { id: 'drafts', type: 'system', name: 'drafts', unreadCount: 0 },
        // { id: 'trash', type: 'system', name: 'trash', unreadCount: 0 },
        // { id: 'spam', type: 'system', name: 'spam', unreadCount: 1 },
        // { id: 'important', type: 'system', name: 'important', unreadCount: 1 },
        // { id: 'starred', type: 'system', name: 'starred', unreadCount: 1 },
        {
          id: 'id_social',
          type: 'custom',
          name: 'social',
          countContact: 0,
          color: '#00AB55'
        },
        {
          id: 'id_promotions',
          type: 'custom',
          name: 'promotions',
          countContact: 0,
          color: '#1890FF'
        },
        {
          id: 'id_forums',
          type: 'custom',
          name: 'forums',
          countContact: 0,
          color: '#FFC107'
        }
      ];
      dispatch(slice.actions.getLabelsSuccess(labels));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMails(params) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      const createLabelIds = (index) => {
        if (index === 1) {
          return ['id_promotions', 'id_forums'];
        }
        if (index === 2) {
          return ['id_forums'];
        }
        if (index === 5) {
          return ['id_social'];
        }
        return [];
      };

      const createAttachment = (index) => {
        if (index === 1) {
          return [mockData.image.feed(1), mockData.image.feed(2)];
        }
        if (index === 2) {
          return [
            'https://mail.google.com/mail/u/file1.docx',
            'https://mail.google.com/mail/u/file2.xlsx',
            'https://mail.google.com/mail/u/file3.pptx',
            'https://mail.google.com/mail/u/file7.sketch'
          ];
        }
        if (index === 5) {
          return [
            mockData.image.feed(1),
            mockData.image.feed(2),
            '/static/mock-images/avatars/avatar_12.mp4',
            'https://mail.google.com/mail/u/file1.docx',
            'https://mail.google.com/mail/u/file2.xlsx',
            'https://mail.google.com/mail/u/file3.pptx',
            'https://mail.google.com/mail/u/file4.pdf',
            'https://mail.google.com/mail/u/file5.psd',
            'https://mail.google.com/mail/u/file6.esp',
            'https://mail.google.com/mail/u/file7.sketch'
          ];
        }
        return [];
      };

      const FOLDER = ['promotions', 'spam', 'inbox', 'folder'];
      // const response = await axios.get('/api/mail/mails', { params });
      const mails = [...Array(9)].map((_, index) => ({
        id: mockData.id(index),
        labelIds: createLabelIds(index + 1),
        folder: sample(FOLDER),
        isImportant: mockData.boolean(index),
        isStarred: mockData.boolean(index),
        isUnread: mockData.boolean(index),
        subject: mockData.text.title(index),
        phoneNumber: mockData.phoneNumber(index),
        createdAt: mockData.time(index),
        files: createAttachment(index),
        from: {
          name: mockData.name.fullName(index),
          email: mockData.email(index),
          avatar:
            index === 1 || index === 2 || index === 5 || index === 6 || index === 8 ? null : mockData.image.avatar(index)
        },
        to: [
          {
            name: 'Jaydon Frankie',
            email: 'demo@minimals.cc',
            avatar: null
          }
        ]
      }));
      dispatch(slice.actions.getMailsSuccess(mails));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMail(mailId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/mail', {
        params: { mailId }
      });
      dispatch(slice.actions.getMailSuccess(response.data.mail));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
